import { render, staticRenderFns } from "./OtherChange.vue?vue&type=template&id=0f77b626&scoped=true&"
import script from "./OtherChange.vue?vue&type=script&lang=js&"
export * from "./OtherChange.vue?vue&type=script&lang=js&"
import style0 from "./OtherChange.vue?vue&type=style&index=0&id=0f77b626&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f77b626",
  null
  
)

export default component.exports